import React from 'react';
import { PromptModal, BackgroundIcon } from '@nile/components';
import Conf from '@nile/home/src/Config/env';
import { SVGIcon } from '@superops/super-icons';

const AddAttachments = (props) => {
  const handleFileAttachments = (files) => {
    props.handleFileAttachments(files);
  };
  return (
    <PromptModal
      id="addAttachmentsBtn"
      description="Upload/drop files here"
      handleSubmit={handleFileAttachments}
      title="Add attachments"
      noIcon
      svg={<SVGIcon name="FileAttachment" color="#323232" />}
      link
      allowMultiple={props?.singleAttachment ? false : true}
      acceptAllType={props?.acceptAllType}
      acceptType={props?.acceptType}
    />
  );
};

export default AddAttachments;
